import React from 'react';
import './FormWrapper.css';

export interface FormWrapperProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

/**
 * Web equivalent of `apps/WunderGuide/common/FormWrapper.tsx`.
 *
 * Centers content vertically + horizontally, with horizontal padding 24 and
 * vertical padding 32 (matches RN scrollContent). On web the keyboard-avoiding
 * + scroll behavior is handled natively by the browser.
 */
const FormWrapper: React.FC<FormWrapperProps> = ({
  children,
  footer,
  className = '',
}) => {
  const combined = `wg-formwrapper ${className}`.trim();
  return (
    <div className={combined}>
      <div className="wg-formwrapper__scroll">
        <div className="wg-formwrapper__inner">{children}</div>
      </div>
      {footer && <div className="wg-formwrapper__footer">{footer}</div>}
    </div>
  );
};

export default FormWrapper;
